export default "__VITE_ASSET__EFVMTpxQ__"